module.exports = __webpack_public_path__ + "418cb941a4f744053220941cd312047c.mp3";